import React from "react";
import { Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Layout from "../Layout/Layout";
import Dashboard from "../Pages/DashboardManagment/Dashboard";
import Login from "../Pages/Auth/Login";
import Profile from "../Pages/Auth/Profile";
import LeadList from "../Pages/Lead Managment/Lead";
import ModuleList from "../Pages/InventryManagment/ModuleManagment/Modulelist";
import AllLeadList from "../Pages/Lead Managment/AllLeads";
import AdminConvertedLeadList from "../Pages/Lead Managment/AdminConvertedLead";
import TodayAllLeadList from "../Pages/Lead Managment/AdminTodayAllLead";
import TodayPendingLeadList from "../Pages/Lead Managment/AdminTodayPendingLead";
import TodayConvertedLeadList from "../Pages/Lead Managment/AdminTodayConvertedLead";
import TodayAssignedLeadList from "../Pages/Lead Managment/AdminTodayAssignedLeads";
import TodayUnAssignedLeadList from "../Pages/Lead Managment/AdminTodayUnAssignLeads";
import AdminTodayNewStaff from "../Pages/Lead Managment/AdminTodayNewStaff";
import TodayLostLeadList from "../Pages/Lead Managment/AdminTodayLostLead";
import AdminAssignLeadList from "../Pages/Lead Managment/AdminAssignLeadList";
import AdminUnAssignLeadList from "../Pages/Lead Managment/AdminUnAssignLeadList";
import AdminLostLeadList from "../Pages/Lead Managment/AdminLostLeadList";
import OtherLeadList from "../Pages/Lead Managment/OtherLeadList";
import StaffPendingLeadList from "../Pages/Lead Managment/StaffPendingLead";
import AdminPendingLeadList from "../Pages/Lead Managment/AdminPendingLead";
import NewLeadList from "../Pages/Lead Managment/NewLead";
import NewAssignLead from "../Pages/Lead Managment/NewAssignLead";
import LeadStaffList from "../Pages/LeadAssignManagment/StaffLeadAssign";
import TaskAssignList from "../Pages/LeadAssignManagment/AssignTasksList";
import ViewLead from "../Pages/Lead Managment/viewLead";
import UpdateLead from "../Pages/Lead Managment/updateLead";
import AddLead from "../Pages/Lead Managment/AddLead";
import StaffList from "../Pages/Staff Managment/Staff";
import StaffActivity from "../Pages/Staff Managment/StaffActivity";
import LogingStaffList from "../Pages/Staff Managment/LoginStaffList";
import DeparmentList from "../Pages/DepartmetnManagment/DepartmentList";
import SuppliersList from "../Pages/InventryManagment/SupplierManagment/Supplierlist";
import AssignView from "../Pages/LeadAssignManagment/View&AssignTask";
import RemarkList from "../Pages/Remark/RemarkList";
import ApiProviderList from '../Pages/ApiProvider/ApiProviderlist';
import RemarkAndStaffList from "../Pages/Lead Managment/RemarkReportingMangment/Remark&LeadCount";
import UpdateRemark from "../Pages/Remark/updateRemark";
import UpdateProduct from "../Pages/InventryManagment/ProductManagment/updateProduct";
import ViewProduct from "../Pages/InventryManagment/ProductManagment/ViewProduct/viewProduct";
import AllRoles from "../Pages/RoleManagment/RoleList";
import AddBlog from "../Pages/Blog/AddBlog";
import Allblog from "../Pages/Blog/Allblog";
import AddStaff from "../Pages/Staff Managment/AddStaff";
import ViewStaff from "../Pages/Staff Managment/ViewStaff";
import UpdateStaff from "../Pages/Staff Managment/EditStaff";
import AllTestimonialpage from "../Pages/Testimonials/AllTestimonials";
import SubCategoriesList from "../Pages/InventryManagment/SubCategoryManagment/SubCategorieslist";
import Categorieslist from "../Pages/InventryManagment/CategoryManagment/Categorieslist";
import AddSubCategory from "../Pages/InventryManagment/SubCategoryManagment/createSubCategory";
import AddPurchase from "../Pages/InventryManagment/PurchaseManagment/createPurchase";
import PurchaseList from "../Pages/InventryManagment/PurchaseManagment/Purchaselist";
import ViewPurchaseProductList from "../Pages/InventryManagment/PurchaseManagment/viewPurchaseProduct";
import AddTestimonial from "../Pages/Testimonials/AddTestimonials";
import createCategory from "../Pages/InventryManagment/CategoryManagment/createCategory";
import AllBrandList from "../Pages/InventryManagment/BrandManagment/Brandlist";
import AllUnitList from "../Pages/InventryManagment/UnitManagment/Unitlist";
import PermissionRoute from "./PermissionRoute";
import ProtectedRoute from "./ProtectedRoute";
import Chat from "../AdminChat/AdminPanel";
import GlobalModal from "../common/GlobalModal";
import ProductGlobalModel from "../common/InventryModels/ProductModel";
// import { getUserRole } from "../Utils/role";
import StaffModal from "../common/StaffModal";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { setLogin } from "../redux/features/authSlice";
import StaffDashboard from "../Pages/DashboardManagment/StaffDashboard";
import AllProductList from "../Pages/InventryManagment/ProductManagment/Productlist";
import AddProduct from "../Pages/InventryManagment/ProductManagment/CreateProductModuls/createProduct";
import AllWhereHouseList from "../Pages/InventryManagment/WhereHouseManagment/WhereHouselist";
import ViewWhereHouseList from "../Pages/InventryManagment/WhereHouseManagment/viewWhereHouse";
import InventryManagment from "../Pages/DashboardManagment/ProductDashboard";
import InventryTransferList from "../Pages/InventryManagment/InventryTransferManagment/InventoryTransferList";
import CreateInventryTransferList from "../Pages/InventryManagment/InventryTransferManagment/CreateInventoryTransfer";
import UpdateInventryTransferList from "../Pages/InventryManagment/InventryTransferManagment/EditInventoryTransfer";
import ViewInventryTransferList from "../Pages/InventryManagment/InventryTransferManagment/ViewInventoryTransfer";
import ClintList from "../Pages/User Managment/ClintList";
import AddClint from "../Pages/User Managment/AddClint";
import UpdateClint from "../Pages/User Managment/EditClint";
import ViewClint from "../Pages/User Managment/ViewClint";
import AllColors from "../Pages/InventryManagment/ColorManagment/Colorlist"
import AllSizeList from "../Pages/InventryManagment/SizeManagment/Sizelist"
import Reminder from "../Pages/Reminder/Reminder";
import ReminderList from "../Pages/Reminder/Reminderlist";
import Meeting from "../Pages/Meeting/AddMeeting";
import Shedulelist from "../Pages/Shedule/Shedulelist";
import Meetinglist from "../Pages/Meeting/Meetinglist";
import EditMeeting from "../Pages/Meeting/EditMeeting";
import CreateDemoCall from "../Pages/Lead Managment/DemoAi/createCall";
import ViewCallDetail from "../Pages/Lead Managment/DemoAi/viewCallDetail";
import FAQ from "../Pages/Lead Managment/FAQ/faq";
import EnquiryList from "../Pages/Lead Managment/EnquiryManagment/Enquirylist";
import AddVendorKyc from "../Pages/kyc Managment/AddKyc";
import BusinessCategoryList from "../Pages/BusinessCategory/BusinessCategorylist";
import PaymentList from "../Pages/PaymentTransactionManagment/PaymentList";
import AllCallingList from "../Pages/Lead Managment/DemoAi/AllCallList";
import CallbackList from "../Pages/Lead Managment/DemoAi/CallbackList";
import OtpVerify from '../Pages/Auth/OtpVerify';
import ModuleFeatures from '../Pages/ModuleFeatures/AddmoduleFeatures';
import OurServicesPage from "../Pages/DashboardManagment/OurServicesPage";
import { getUserRole, isVendorAdmin } from "../Utils/role";
import SubscriptionHistory from "../Pages/wallet Managment/SubscriptionHistory";
import AllTransaction from "../Pages/wallet Managment/paymentlsit";
import AllNotifications from "../Pages/Notification Managment/NotificationList";
const AppRoutes = () => {
  // const { role, permissions } = useSelector((state) => state.auth);
   const { role: _rawRole, permissions } = useSelector((state) => state.auth);
  const role = typeof _rawRole === "string" ? _rawRole.toLowerCase() : "";
  const effectiveRole = role || getUserRole();
  const vendorAdmin = isVendorAdmin() || effectiveRole === "vender";
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  // useEffect(() => {
  //   const fetchPermissions = async () => {
  //     try {
  //       const token = Cookies.get("adminToken");
  //       if (!token) return;
  //       const staffData = localStorage.getItem("admin");
  //       const admin = staffData ? JSON.parse(staffData) : null;
  //       if (!admin) return;
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_BASE_URL}/admin/staff-permissions`,
  //         {
  //           method: "POST",
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ id: admin.id }),
  //         }
  //       );
  //       const result = await response.json();
  //       if (result.success) {
  //         dispatch(
  //           setLogin({
  //             admin,
  //             token,
  //             role: result.data.role,
  //             permissions: result.data.staff_permission || {},
  //           })
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Permission Error:", error);
  //     }
  //   };
  //   fetchPermissions();
  // }, [dispatch]);

  // const hasAnyPermission = permissions &&
  //   Object.entries(permissions).some(
  //     ([key, value]) =>
  //       key !== "id" &&
  //       key !== "admin_id" &&
  //       key !== "created_at" &&
  //       key !== "updated_at" &&
  //       value == 1
  //   );
    
  return (
    <>
      <Routes>
        <Route path="/Login" element={<Login />} />
        <Route path="/otp-verify" element={<OtpVerify />} />

        {/* <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="dashboard" permissions={permissions} role={role}>
                <Layout>
                  <Dashboard />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          } 
        /> */}

        <Route
          path="/staff-dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <StaffDashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/module-features/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ModuleFeatures />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/inventry-dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <InventryManagment />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout>
                {vendorAdmin ? (
                  <Dashboard />
                ) : permissions?.dashboard === 1 ? (
                  <Dashboard />
                ) : (
                  <StaffDashboard />
                )}
{/* 
                {vendorAdmin ? (
  <Dashboard />
) : permissions?.dashboard === 1 ? (
  <Dashboard />
) : (
  <StaffDashboard />
)} */}
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout>
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/our-services"
          element={
                 <ProtectedRoute>
            {/* <PermissionRoute permissionKey="role" permissions={permissions} role={role}> */}
              <Layout>
                <OurServicesPage />
              </Layout>
            {/* </PermissionRoute> */}
            </ProtectedRoute>
          }
        />


              <Route
          path="/role-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="role" permissions={permissions} role={role}>
                <Layout>
                  <AllRoles />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
              <Route
          path="/add-kyc"
          element={
            <ProtectedRoute>
              {/* <PermissionRoute permissionKey="kyc" permissions={permissions} role={role}> */}
                <Layout>
                  <AddVendorKyc />
                </Layout>
              {/* </PermissionRoute> */}
            </ProtectedRoute>
          }
        />

        <Route
          path="/all-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <AllLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/brand-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="brand" permissions={permissions} role={role}>
                <Layout>
                  <AllBrandList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />


            <Route
          path="/all-notification-list"
          element={
            <ProtectedRoute>
              {/* <PermissionRoute permissionKey="notification" permissions={permissions} role={role}> */}
                <Layout>
                  <AllNotifications />
                </Layout>
              {/* </PermissionRoute> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="/product-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="product" permissions={permissions} role={role}>
                <Layout>
                  <AllProductList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-product"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="addproduct" permissions={permissions} role={role}>
                <Layout>
                  <AddProduct />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-purchase"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="purchase" permissions={permissions} role={role}>
                <Layout>
                  <AddPurchase />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />





        
<Route
  path="/my-subscriptions"
  element={
    <ProtectedRoute>
      <PermissionRoute permissionKey="subscription" permissions={permissions} role={role}>
        <Layout>
          <SubscriptionHistory />
        </Layout>
      </PermissionRoute>
    </ProtectedRoute>
  }
/>
<Route
  path="/subscriptions-transactions-list"
  element={
    <ProtectedRoute>
      <PermissionRoute permissionKey="subscription" permissions={permissions} role={role}>
        <Layout>
          <AllTransaction />
        </Layout>
      </PermissionRoute>
    </ProtectedRoute>
  }
/>



        <Route
          path="/purchase-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="purchase" permissions={permissions} role={role}>
                <Layout>
                  <PurchaseList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/module-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="module" permissions={permissions} role={role}>
                <Layout>
                  <ModuleList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/enquries-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="enquiry" permissions={permissions} role={role}>
                <Layout>
                  <EnquiryList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase-product-list/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="purchase" permissions={permissions} role={role}>
                <Layout>
                  <ViewPurchaseProductList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/wherehouse-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="wherehouse" permissions={permissions} role={role}>
                <Layout>
                  <AllWhereHouseList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-wherehouse-list/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="wherehouse" permissions={permissions} role={role}>
                <Layout>
                  <ViewWhereHouseList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/activity-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="activity" permissions={permissions} role={role}>
                <Layout>
                  <StaffActivity />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/unit-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="unit" permissions={permissions} role={role}>
                <Layout>
                  <AllUnitList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/transfer-inventroy-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="stocktransfer" permissions={permissions} role={role}>
                <Layout>
                  <InventryTransferList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-transfer-inventroy"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="stocktransfer" permissions={permissions} role={role}>
                <Layout>
                  <CreateInventryTransferList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-transfer-inventroy/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="stocktransfer" permissions={permissions} role={role}>
                <Layout>
                  <UpdateInventryTransferList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-transfer-inventroy/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="stocktransfer" permissions={permissions} role={role}>
                <Layout>
                  <ViewInventryTransferList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/other-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <OtherLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  {/* {role === "vender" ? <LeadList /> : <OtherLeadList />} */}
                   <LeadList /> 

                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/staff-pending-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="pendinglead" permissions={permissions} role={role}>
                <Layout>
                  <StaffPendingLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/vendor-pending-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="pendinglead" permissions={permissions} role={role}>
                <Layout>
                  <AdminPendingLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/new-assign-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="newlead" permissions={permissions} role={role}>
                <Layout>
                  <NewAssignLead />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/new-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="newlead" permissions={permissions} role={role}>
                <Layout>
             
                  {vendorAdmin ? <NewLeadList /> : <NewAssignLead />}
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/new-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="newlead" permissions={permissions} role={role}>
                <Layout>
                  {/* {role === "vender" ? <NewLeadList /> : <NewAssignLead />} */}
                  <NewLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 11. LEAD STAFF LIST (Assigned Lead) */}
        <Route
          path="/lead-staff-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="LeadAssigned" permissions={permissions} role={role}>
                <Layout>
                  <LeadStaffList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 12. ADMIN CONVERTED LEAD LIST */}
        <Route
          path="/admin-converted-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <AdminConvertedLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 13. TODAY ALL LEAD LIST */}
        <Route
          path="/today-all-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <TodayAllLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 14. TODAY PENDING LEAD LIST */}
        <Route
          path="/today-pending-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="pendinglead" permissions={permissions} role={role}>
                <Layout>
                  <TodayPendingLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 15. TODAY CONVERTED LEAD LIST */}
        <Route
          path="/today-converted-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <TodayConvertedLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 16. TODAY ASSIGNED LEAD LIST */}
        <Route
          path="/today-assigned-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="LeadAssigned" permissions={permissions} role={role}>
                <Layout>
                  <TodayAssignedLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 17. TODAY UNASSIGNED LEAD LIST */}
        <Route
          path="/today-unassigned-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <TodayUnAssignedLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 18. TODAY NEW STAFF LIST */}
        <Route
          path="/today-new-staff-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="staff" permissions={permissions} role={role}>
                <Layout>
                  <AdminTodayNewStaff />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 19. TODAY LOST LEAD LIST */}
        <Route
          path="/today-lost-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <TodayLostLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 20. ADMIN LOST LEAD LIST */}
        <Route
          path="/admin-lost-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <AdminLostLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 21. ADMIN ASSIGN LEAD LIST */}
        <Route
          path="/admin-assign-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="LeadAssigned" permissions={permissions} role={role}>
                <Layout>
                  <AdminAssignLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 22. ADMIN UNASSIGN LEAD LIST */}
        <Route
          path="/admin-unassign-lead-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <AdminUnAssignLeadList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 23. ASSIGNED TASK LIST */}
        <Route
          path="/assignd-task-list/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="LeadAssigned" permissions={permissions} role={role}>
                <Layout>
                  <TaskAssignList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 24. VIEW LEAD */}
        <Route
          path="/view-lead/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <ViewLead />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 25. UPDATE LEAD */}
        <Route
          path="/update-lead/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <UpdateLead />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 26. ADD LEAD */}
        <Route
          path="/add-lead"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="newlead" permissions={permissions} role={role}>
                <Layout>
                  <AddLead />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-demo-call"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="demo" permissions={permissions} role={role}>
                <Layout>
                  <CreateDemoCall />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-call-detail/:phone"
          element={
            <ProtectedRoute>
              {/* <PermissionRoute permissionKey="demo" permissions={permissions} role={role}> */}
                <Layout>
                  <ViewCallDetail />
                </Layout>
              {/* </PermissionRoute> */}
            </ProtectedRoute>
          }
        />

        {/* 27. STAFF LIST */}
        <Route
          path="/staff-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="staff" permissions={permissions} role={role}>
                <Layout>
                  <StaffList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-calling-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="lead" permissions={permissions} role={role}>
                <Layout>
                  <AllCallingList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/callback-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="callback" permissions={permissions} role={role}>
                <Layout>
                  <CallbackList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 28. LOGGED STAFF LIST */}
        <Route
          path="/logged-staff-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="staff" permissions={permissions} role={role}>
                <Layout>
                  <LogingStaffList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 29. DEPARTMENT LIST */}
        <Route
          path="/deparment-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="department" permissions={permissions} role={role}>
                <Layout>
                  <DeparmentList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/supplier-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="suppliers" permissions={permissions} role={role}>
                <Layout>
                  <SuppliersList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/remark-history/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <RemarkList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 31. REMARK STAFF LIST */}
        <Route
          path="/remark-staff-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <RemarkAndStaffList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 32. REMARK STAFF LIST WITH ID */}
        <Route
          path="/remark-staff-list/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <RemarkList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/update-remark/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="alllead" permissions={permissions} role={role}>
                <Layout>
                  <UpdateRemark />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-product/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="product" permissions={permissions} role={role}>
                <Layout>
                  <UpdateProduct />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-product/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="product" permissions={permissions} role={role}>
                <Layout>
                  <ViewProduct />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 34. ADD STAFF */}
        <Route
          path="/add-staff"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="staff" permissions={permissions} role={role}>
                <Layout>
                  <AddStaff isModal={false} />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 35. VIEW STAFF */}
        <Route
          path="/view-staff/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="staff" permissions={permissions} role={role}>
                <Layout>
                  <ViewStaff />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 36. UPDATE STAFF */}
        <Route
          path="/update-staff/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="staff" permissions={permissions} role={role}>
                <Layout>
                  <UpdateStaff />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 37. ALL BLOG */}
        <Route
          path="/all-blog"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="blog" permissions={permissions} role={role}>
                <Layout>
                  <Allblog />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-blog"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="blog" permissions={permissions} role={role}>
                <Layout>
                  <AddBlog />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/all-testimonial"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="testimonial" permissions={permissions} role={role}>
                <Layout>
                  <AllTestimonialpage />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-testimonial"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="testimonial" permissions={permissions} role={role}>
                <Layout>
                  <AddTestimonial />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        {/* 43. CATEGORIES LIST */}
        <Route
          path="/categories-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="inventoryManagement" permissions={permissions} role={role}>
                <Layout>
                  <Categorieslist />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sub-categories-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="inventoryManagement" permissions={permissions} role={role}>
                <Layout>
                  <SubCategoriesList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* 45. ASSIGN VIEW */}
        <Route
          path="/assign-view/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="LeadAssigned" permissions={permissions} role={role}>
                <Layout>
                  <AssignView />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/*user Routre */}
        <Route
          path="/user-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="user" permissions={permissions} role={role}>
                <Layout>
                  <ClintList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/Payment-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="paymentlist" permissions={permissions} role={role}>
                <Layout>
                  <PaymentList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/api-provider-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="paymentlist" permissions={permissions} role={role}>
                <Layout>
                  <ApiProviderList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/faq"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="lead" permissions={permissions} role={role}>
                <Layout>
                  <FAQ />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-user"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="user" permissions={permissions} role={role}>
                <Layout>
                  <AddClint />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/update-user/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="user" permissions={permissions} role={role}>
                <Layout>
                  <UpdateClint />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/color-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="color" permissions={permissions} role={role}>
                <Layout>
                  <AllColors />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/size-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="size" permissions={permissions} role={role}>
                <Layout>
                  <AllSizeList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-user/:id"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="user" permissions={permissions} role={role}>
                <Layout>
                  <ViewClint />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-meeting"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="meeting" permissions={permissions} role={role}>
                <Layout>
                  <Meeting />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/meeting-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="meeting" permissions={permissions} role={role}>
                <Layout>
                  <Meetinglist />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shedule-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="visit" permissions={permissions} role={role}>
                <Layout>
                  <Shedulelist />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/schedule-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="visit" permissions={permissions} role={role}>
                <Layout>
                  <Shedulelist />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-meeting"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="meeting" permissions={permissions} role={role}>
                <Layout>
                  <EditMeeting />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reminder"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="reminder" permissions={permissions} role={role}>
                <Layout>
                  <Reminder />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reminder-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="reminder" permissions={permissions} role={role}>
                <Layout>
                  <ReminderList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/business-category-list"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="businessCategoryList" permissions={permissions} role={role}>
                <Layout>
                  <BusinessCategoryList />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />




        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <PermissionRoute permissionKey="chat" permissions={permissions} role={role}>
                <Layout>
                  <Chat />
                </Layout>
              </PermissionRoute>
            </ProtectedRoute>
          }
        />

        {/* ==================== 404 - NOT FOUND (Optional) ==================== */}
        <Route
          path="*"
          element={
            <ProtectedRoute>
              {/* <Layout>
                <div style={{ padding: "50px", textAlign: "center" }}>
                  <h2>404 - Page Not Found</h2>
                </div>
              </Layout> */}
                    <Navigate to="/" replace />
            </ProtectedRoute>
          }
        />

      </Routes>

      <GlobalModal />
      <ProductGlobalModel />
      <StaffModal />
    </>
  );
};

export default AppRoutes;